import { cn } from '@immo/ui-kit';

type Props = {
  /** 0–100; `null` = the figure was never reported. */
  readonly fill: number | null;
  /** Tick position, 0–100. */
  readonly limit?: number;
  /** Tick position, 0–100. */
  readonly resume?: number;
  readonly warning: boolean;
  readonly className?: string;
};

/** Presentational: the figure's text carries the value, so the bar is hidden from assistive tech. */
export function HealthBar({ fill, limit, resume, warning, className }: Props) {
  const missing = fill === null;

  return (
    <span
      role="presentation"
      className={cn(
        'relative block h-1.5 overflow-hidden rounded-full',
        missing ? 'border border-dashed border-neutral-300 bg-transparent' : 'bg-neutral-100',
        className,
      )}
    >
      {!missing && (
        <>
          <span
            className={cn('absolute inset-y-0 left-0 rounded-full', warning ? 'bg-warning-500' : 'bg-info-500')}
            style={{ width: `${fill}%` }}
          />
          {limit !== undefined && (
            <span className="absolute inset-y-0 w-px bg-neutral-300" style={{ left: `${limit}%` }} />
          )}
          {resume !== undefined && (
            <span className="absolute inset-y-0 w-px bg-neutral-400/60" style={{ left: `${resume}%` }} />
          )}
        </>
      )}
    </span>
  );
}
